import { render, staticRenderFns } from "./OrgChartPanel.vue?vue&type=template&id=64ee8857&scoped=true"
import script from "./OrgChartPanel.vue?vue&type=script&lang=js"
export * from "./OrgChartPanel.vue?vue&type=script&lang=js"
import style0 from "./OrgChartPanel.vue?vue&type=style&index=0&id=64ee8857&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee8857",
  null
  
)

export default component.exports